(() => {
  'use strict';
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  let closeTimer;
  const selector = '[data-neb-v10-mega]';
  document.addEventListener('pointerover', event => {
    const menu = event.target.closest(selector);
    if (!menu) return;
    clearTimeout(closeTimer);
    document.querySelectorAll(selector).forEach(other => { other.open = other === menu; });
  });
  document.addEventListener('click', event => {
    const summary = event.target.closest('[data-neb-v10-mega] > summary');
    if (!summary || event.detail === 0) return;
    event.preventDefault();
    clearTimeout(closeTimer);
    const menu = summary.parentElement;
    document.querySelectorAll(selector).forEach(other => { other.open = other === menu; });
  });
  document.addEventListener('pointerout', event => {
    const menu = event.target.closest(selector);
    if (!menu || (event.relatedTarget && menu.contains(event.relatedTarget))) return;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => { if (!menu.matches(':hover') && !menu.matches(':focus-within')) menu.open = false; },180);
  });
  document.addEventListener('focusin', event => {
    const menu = event.target.closest(selector);
    if (menu) document.querySelectorAll(selector).forEach(other => { if (other !== menu) other.open = false; });
  });
})();
